export default defineNuxtRouteMiddleware(async () => {
  const store = useUserStore();

  if (!store.user) {
    return navigateTo("/");
  }
});
